import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 80%;
  justify-content: space-between;
  padding-top: 5rem;
  text-align: center;
`;
